import { pluralize } from "@entrilia/shared/utilities/stringHelper";
import type { ContactChangesState, ContactRemovals } from "./contactChangesState";
import { getUnsavedChangesCount } from "./contactChangesState";

export const getChangesCountChipLabel = (changesCount: number): string =>
  `${changesCount} ${pluralize("Change", changesCount)}`;

export const getUnsavedChangesLabel = (state: ContactChangesState): string => {
  const count = getUnsavedChangesCount(state);
  return `${count} unsaved ${pluralize("change", count)}`;
};

// A pending removal may cover only some of the contact's funds, and the collapsed group would misread as a whole-member removal
export const getContactRemovalChipLabel = (
  removals: ContactRemovals,
  contactId: string,
  getFundCount: () => number
): string | undefined => {
  if (removals.removedContactIds.includes(contactId)) {
    return "Removing";
  }

  const removedFundCount = removals.removedContactFunds.filter((removal) => removal.contactId === contactId).length;
  if (removedFundCount === 0) {
    return undefined;
  }

  return removedFundCount >= getFundCount()
    ? "Removing"
    : `Removing from ${removedFundCount} ${pluralize("fund", removedFundCount)}`;
};
